<template>
    <div>

        <div class="top-div">
            <div class="width-div" style="display: flex;justify-content: space-between;">
                <div>
                    <div>
                        <img src="../../public/static/img/achievement/成果对接.png" class="big-title">
                    </div>
                    <div>
                        <el-input
                            v-model="inputV"
                            class="input-div"
                            placeholder="请输入成果名称搜索"
                            @keydown="searchKeyDown"
                        >
                            <template #suffix>
                                <el-icon class="el-input__icon">
                                    <Search @click="toTechRes('')"/>
                                </el-icon>
                            </template>
                        </el-input>
                    </div>
                </div>
                <div class="achievement_count">
                    <span class="achievement_count_text">共享平台已收录</span>
                    <span class="achievement_count_number">
                        {{ achievementCount }}
                    </span>
                    <span class="achievement_count_text">成果。</span>

                </div>
            </div>
        </div>


        <div class="introduce-div">
            <div class="width-div" style="display: flex;justify-content: space-between;">
                <div class="introduce-main" @click="toTechDesc">
                    <img src="../../public/static/img/achievement/成果介绍.svg" style="width: 50px;height: 50px;">
                    <span>
                        <span class="introduce-title">成果展示介绍</span><br/>
                        <span class="introduce-desc">
                            展示科研成果，推动转化落地
                        </span>
                    </span>
                </div>
                <div class="introduce-main"  @click="toLib">
                    <img src="../../public/static/img/achievement/成果录入.svg" style="width: 50px;height: 50px;">
                    <span>
                        <span class="introduce-title">录入成果入口</span><br/>
                        <span class="introduce-desc">
                            提供便捷通道，供提交科研成果
                        </span>
                    </span>
                </div>
                <div class="introduce-main" @click="toHelp">
                    <img src="../../public/static/img/achievement/成果教程.svg" style="width: 50px;height: 50px;">
                    <span>
                        <span class="introduce-title">录入成果教程</span><br/>
                        <span class="introduce-desc">
                            成果录入指南及各项须知
                        </span>
                    </span>
                </div>
            </div>


        </div>

        <div class="keynote-div">
            <div class="width-div">
                <div class="keynote-title-div">
                    <span class="keynote-title">
                        重点成果
                    </span>
                    <span class="keynote-more">
                        <el-link :underline="true" @click="toTechRes('1')">查看更多></el-link>
                    </span>

                </div>
                <div class="keynote-main">

                    <div class="keynote-main-content" v-for="(item, index) in keynoteDataList">
                        <div class="keynote-main-content-title">
                            <span class="keynote-main-content-title-link" @click="toInstrument(item.id)">{{item.resultsName}}</span>
                        </div>
                        <div class="keynote-main-content-desc">
                            {{item.keyTechnology}}
                        </div>
                        <div class="keynote-main-content-footer">
                            <div class="keynote-main-content-footer-div">
                                <el-tag type="primary">{{item.belongDomainName}}</el-tag>
                                <el-button type="primary" plain size="small" @click="toInstrument(item.id)">了解详情</el-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div class="classification-div">
            <div class="width-div">
                <div class="keynote-title-div">
                    <span class="keynote-title">
                        成果分类
                    </span>
                </div>
                <div style="margin-top: 20px;">
                    <el-carousel ref="carouselRef" height="450px" :autoplay="false" indicator-position="none"
                                 :motion-blur="true" arrow="never">
                        <el-carousel-item v-for="(groupIndex, i) in Math.ceil(achievementAreasDictList.length / 3)"
                                          :key="groupIndex">
                            <div style="display: flex;justify-content: space-between;">
                                <el-card class="classification-el-card"
                                         v-for="(item, itemIndex) in achievementAreasDictList.slice((groupIndex - 1) * 3,Math.min(groupIndex * 3, achievementAreasDictList.length))"
                                         :key="item.dictVal || itemIndex"
                                >
                                    <template #header>
                                        <div class="card-header">
                                            <span   >
                                                <img :src="$getImage(item.dictIcon)" style="width: 20px; heigh: 20px;">
                                                <span style="font-family: 思源黑体;
                                                    font-size: 20px;
                                                    font-weight: 500;margin-left: 10px;">{{ item.dictName }}</span>
                                            </span>
                                            <span class="keynote-more">
                                                <el-link :underline="true" @click="toTechRes('')">查看更多></el-link>
                                            </span>
                                        </div>
                                    </template>
                                    <div class="classification-el-card-main">

                                        <p  class="classification-el-card-p"
                                            v-if="item.dataList && item.dataList.length > 0"
                                            v-for="(pData,index) in item.dataList"
                                            :key="index"
                                            @click="toInstrument(pData.id)">
                                            <img src="../../public/static/img/achievement/成果icon.svg"
                                                 style="width: 20px;height: 20px;">
                                            <span class="classification-el-card-p-span"
                                                  style="margin-left: 10px;">
                                                {{pData.resultsName}}</span>

                                        </p>

                                        <el-empty description="暂无数据" v-else />
                                    </div>

                                </el-card>

                            </div>
                        </el-carousel-item>

                    </el-carousel>

                </div>
                <div style="display: flex;justify-content: center;padding-bottom: 50px;">
                    <el-pagination layout="prev, pager, next" :background="false" :default-page-size="3"
                                   :total="achievementAreasDictList.length" @current-change="currentChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {Calendar, Search} from '@element-plus/icons-vue'
import {ref, onMounted, getCurrentInstance} from 'vue'
import CommonUtil from "@/utils/common";
import { ElMessage } from 'element-plus'
// 直接定义变量和方法，无需 return

const {proxy} = getCurrentInstance();
const count = ref(0);


const inputV = ref('')




const carouselRef = ref(null)
//分页器改变
const currentChange = (val) => {
    console.log(val)
    carouselRef.value.setActiveItem(val - 1);
}

const achievementCount = ref(0);

const getAchievementCount = () => {
    proxy.$http.post('/gdsti2/resource/a/resDataFormResearch/count').then(res => {
        if (res.data.state == 0) {
            achievementCount.value = res.data.result
        }
    }).catch(err => {

    });
}

const searchKeyDown = (e) => {
    if (e.keyCode === 13) {
        toTechRes('');
    }
}

const toHelp = async () => {

    HFAlert('成果教程暂未开放')

    // window.open('/help');

}

const toLib = async () => {
    var userInfo = proxy.$store.state.userInfo;
    if (userInfo && userInfo.userCode) {
        let isPlatformAdmin = await CommonUtil.isPlatformAdmin();

        if (isPlatformAdmin) {
            proxy.$router.push({name: 'LibPrincipalResults', path: '/user/libPrincipalResults', })
        } else {
            ElMessage.error('您没有权限，只有平台负责人才能进行成果录入。');
        }
    } else {
        ElMessage.error("请先登录");

    }

}

const toTechDesc = () => {

    proxy.$router.push({name: 'Tech', path: '/tech', query:{index: 5}})

}

const toTechRes = (isKeynote) => {

    let query = {
        cname: inputV.value,
        id: 'RESEARCH_DATA',
        name: '科研成果',
        isKeynote: isKeynote,
    };


    proxy.$router.push({path: '/techRes', name: 'TechRes', query: query})
}

//8个重点成果
const keynoteDataList = ref([])

const getKeynoteData = () => {

    let param = {
        showHomePage: 1,
        noPage: 1,
    }
    proxy.$http.post('/gdsti2/resource/a/resDataFormResearch/list', param).then(res => {
        if (res.data.state == 0) {
            keynoteDataList.value = res.data.result
        }
    }).catch(err => {

    });

}

//跳转成果详情
const toInstrument = (id) =>{
    // let query = {
    //     id: id,
    //     catalogType: 'RESEARCH_DATA'
    // };

    window.open('/instrument?id='+id+'&catalogType=RESEARCH_DATA');
    // proxy.$router.push({path: '/instrument', name: 'Instrument', query: query})
}

const achievementAreasDictList = ref([])

const getAchievementAreasDictList = () => {

    proxy.$http.post('/gdsti2/resource/a/resDataFormResearch/classificationList').then(res => {
        if (res.data.state == 0) {
            achievementAreasDictList.value = res.data.result
        }
    }).catch(err => {

    });
}


onMounted(() => {
    getAchievementCount();
    getKeynoteData();
    getAchievementAreasDictList();
});

</script>

<style lang="less" scoped>
.card-header {
    display: flex;
    justify-content: space-between;
}

.classification-el-card-p-span {
    white-space: nowrap; /* 强制文本不换行 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    //width: 200px; /* 必须指定容器宽度（固定值或百分比） */

    width: calc(100% - 20px);
}

.classification-el-card-p {
    box-sizing: border-box;
    border: 1px solid #E4E9F4;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
}
.classification-el-card-p:hover{
    cursor: pointer;
}
.classification-el-card-main {

}

.classification-el-card {
    width: 32%;
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    height: 400px;
}

.keynote-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

}

.keynote-main-content {
    margin-top: 20px;
    width: 23%;
    background: #FFFFFF;
    box-shadow: 1px 3px 8px 1px rgba(0, 0, 0, 0.16);
    border-radius: 11px;
    border: 1px solid white;
    height: 250px;
    position: relative;
    margin-left: 1%;
    margin-right: 1%;
    box-sizing: border-box;
}

.keynote-main-content-footer-div {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
}


.keynote-main-content-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 44px;
}

.keynote-main-content-desc {
    font-family: Microsoft YaHei;
    font-size: 13px;
    font-weight: normal;
    line-height: 18px;
    padding: 10px 20px 0 20px;
    color: #8A8A8A;
    //height: calc(250px - 107px - 44px);



    display: -webkit-box;
    -webkit-line-clamp: 4; /* 显示的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;



}

.keynote-main-content-title-link:hover{
    cursor: pointer;
    //下划线
    text-decoration: underline; /* 下划线效果 */
}
.keynote-main-content-title-link{

}
.keynote-main-content-title {
    height: 72px;
    margin-top: 15px;
    background: linear-gradient(90deg, #007EEC 0%, #5BB3FF 100%);
    color: white;
    padding: 10px 20px;
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: bold;
}

.classification-div {
    display: flex;
    justify-content: center;
    margin-top: 70px;
    background-image: url('../../public/static/img/achievement/下半部背景.png') ;

    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-top: 50px;
}

.keynote-div {
    display: flex;
    justify-content: center;
    margin-top: 70px;
}

.keynote-title {
    font-family: "DingTalk JinBuTi";
    font-size: 34px;
    font-weight: normal;
    line-height: 29px;
}

.keynote-title-div {
    display: flex;
    justify-content: space-between;
}

.width-div {
    width: 1200px;
}

.achievement_count {
    background-image: url('../../public/static/img/achievement/成果数量背景.svg');
    width: 462px;
    height: 115px;
    text-align: center;
    line-height: 115px;
    margin-top: 100px;
}

.achievement_count_text {
    color: #007EEC;
    font-size: 30px;
    font-weight: normal;
    line-height: 36px;
    font-family: "DingTalk JinBuTi";
    letter-spacing: 0px;
    font-weight: normal;
}

.achievement_count_number {
    color: #EC950A;
    font-size: 30px;
    font-weight: normal;
    line-height: 36px;
    font-family: "DingTalk JinBuTi";
    letter-spacing: 0px;
    font-weight: normal;
}

.top-div {
    background-image: url('../../public/static/img/achievement/上半部背景.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 350px;
    opacity: 1;
    display: flex;
    justify-content: center;
}

.big-title {
    margin-top: 80px;
}

.input-div {
    margin-top: 30px;
    width: 477px;
    height: 65px;
    opacity: 1;

}

.el-input__icon {
    font-size: 24px;
}

.el-input__icon:hover {
    cursor: pointer;
}

/deep/ .input-div .el-input__wrapper {
    border-radius: 65px;
    padding-left: 25px;
    padding-right: 25px;
}

.introduce-title {
    font-family: Microsoft YaHei;
    font-size: 22px;
    font-weight: normal;
    line-height: 29px;
}

.introduce-desc {
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: normal;
    line-height: 29px;
    opacity: 1;
    color: #8A8A8A;

    display: -webkit-box;
    -webkit-line-clamp: 1; /* 显示的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.introduce-div {
    display: flex;
    justify-content: center;
    margin-top: -50px;
    opacity: 1;
}

.introduce-main {
    background: linear-gradient(180deg, #F4F3F8 0%, rgba(255, 255, 255, 0) 97%);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    box-shadow: 0px 2px 6px 0px #BDD7F9;
    border: 5px solid white;
    padding: 10px 20px;
    opacity: 1;
    background-color: white;

    width: 28%;

}
.introduce-main:hover{
    cursor: pointer;
}
</style>


